module.exports = "<button type=\"submit\" (click)=\"checkStatus('approved')\" md-raised-button color=\"accent\" class=\"btn-w-sm btn-w-md color-white font-size-12px approve-reject\"><span class=\"btn-text\">{{ 'APPROVE SELECTED' | translate }}</span></button>\n<span class=\"space-xs\"></span>\n<button type=\"submit\" (click)=\"checkStatus('rejected')\"  md-raised-button class=\"btn-w-sm btn-w-md btn-red font-size-12px approve-reject\"><span class=\"btn-text\">{{ 'REJECT SELECTED' | translate }}</span></button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/multi-approve-reject/multi-approve-reject.component.html
// module id = 1274
// module chunks = 10